import { fetchToken } from '@/services';
import { getSafeFileName } from '@/utils/fileUtil';
import { t } from '@/utils/helper/intl';
import { ErrorType } from '@/utils/Uploader/type';

import {
  IRequestTokenData,
  ITokenData,
  IUpload,
  IUploadInstanceOptions,
  UploadType,
} from '../type';
import { AwsUploader } from './Uploader/AwsUploader';
import { CosUploader } from './Uploader/CosUploader';
import { OssUploader } from './Uploader/OssUploader';

// 普通上传
export class Uploader {
  private helper: OssUploader | AwsUploader | CosUploader | null = null;
  private isCanceled: boolean = false;
  constructor(private options: IUploadInstanceOptions = {}) {}

  static getInstance(options?: IUploadInstanceOptions) {
    return new Uploader(options || {});
  }
  // 上传
  public async upload(options: IUpload): Promise<string> {
    const { tokenData, file, fileUid } = options;
    const { onError } = this.options;
    const start = new Date().getTime();
    const authData = await this.getAuthData(tokenData);
    if (!authData) {
      const end = new Date().getTime();
      const error = new Error(t('Token-Data'));
      error.name = ErrorType.Other;
      const err = {
        name: error.name,
        message: error.message,
        error,
        start,
        end,
      };
      onError && onError(err, fileUid || '');
      return '';
    }

    const { ossType } = authData;

    const helper =
      ossType === UploadType.AWS
        ? new AwsUploader(this.options)
        : ossType === UploadType.OSS
          ? new OssUploader(this.options)
          : new CosUploader(this.options);

    this.helper = helper;
    if (this.isCanceled) {
      this.isCanceled = false;
      return '';
    }
    const url = await helper.upload({ file, fileUid, tokenData: authData });
    return url || '';
  }

  // 取消上传
  public async cancel() {
    const helper = this.helper;
    this.isCanceled = true;
    if (!helper) return false;
    const res = await helper.cancel();

    return res;
  }
  // 取消上传
  public async cancelUpload() {
    const helper = this.helper;
    this.isCanceled = true;
    if (!helper) return false;
    return await helper.cancel();
  }

  // 重试
  public async retry() {
    const helper = this.helper;
    if (!helper) return false;
    return await helper.retry();
  }

  // 拿到oss的ak&sk&bucket等信息
  private async getAuthData(params: IRequestTokenData): Promise<ITokenData | null> {
    try {
      const { fileName, dirSceneType } = params;
      const name = getSafeFileName(fileName);
      const data = await fetchToken(name, dirSceneType);
      if (data.code !== 200 || !data.data) return null;
      return data.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
